// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-input[data-v-1aa0f6d2] {\n  width: 287px !important;\n}", ""]);
// Exports
module.exports = exports;
